import * as userRequest from "@/utils/userRequest";

export interface MissionDataType {
    social: string;
    value: string;
}

export enum PASSCODE_STATUS {
    ACTIVE = "active",
    INACTIVE = "inactive",
}

export interface UpdateUserInfoType {
    avatar?: string;
    nick_name?: string;
    description?: string;
    mission_data?: MissionDataType[];
    passcode?: PASSCODE_STATUS;
    settings?: {
        locale?: string;
        currency?: string;
        country?: string;
    };
}

const updateUserInfoService = async (
    token: string,
    userInfo: UpdateUserInfoType,
    onSuccess?: (data?: any) => any,
    handleError?: (err?: any) => any
) => {
    try {
        const response = await userRequest.patch(
            "/user/update-user-info",
            {
                ...userInfo,
            },
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (response?.success) {
            onSuccess && onSuccess(response);
            return response;
        } else {
            throw new Error("failed to update user info");
        }
    } catch (error) {
        console.error("🚀 ~ updateUserInfoService ~ error:", error);
        if (handleError) {
            handleError(error);
        }
        throw error;
    }
};

export default updateUserInfoService;
